// Pure helpers for IDI payment UI, extracted from
// idi_stakeholders.component.js (RPR-6861/6862) so the generation guard and — critically — the
// is_idi_generation marker that distinguishes a generated honorarium from a manual one are
// unit-testable in the karma harness (portal/test/idi_generate_payment.spec.js). The component
// controller is not reachable without angular-mocks, but these plain functions are. Deliberately
// plain globals (not an Angular service), matching services/fusion_action_menu.js.
// availablePaymentTypeOptions serves the Honorarium screen's New Manual Payment dialog, not the
// Generate Payments action — so this file outlives that flow if it is ever retired.

// Returns a human-readable reason the payment must not be generated, or null when it may proceed.
// `constants` is the CONSTANTS service (source of the third-party message). A manual Honorarium
// payment no longer blocks generation (RPR-6861), so the guard keys on has_generated_payment, not
// has_payment — otherwise a manual-first stakeholder could never be paid the honorarium.
globalThis.idiPaymentBlockedReason = function (row, remuneration, constants) {
  if (!row) return 'Stakeholder not found';
  if (row.is_third_party) return constants.thirdPartyStakeholder.NO_PAYMENT_GENERATION;
  if (row.has_generated_payment) return 'Payment has already been generated for this stakeholder.';
  if (row.stakeholder_locked || !row.stakeholder_active) {
    return 'Payment cannot be generated for a deactivated/locked payer.';
  }
  if (!remuneration?.rate) {
    return 'No remuneration rate found for this stakeholder. Please add remuneration rate in the Manage Records.';
  }
  return null;
};

// Builds the POST body for /api/admin/payer/fee.json that generates an IDI honorarium.
// is_idi_generation:true is what marks the payment as generated (a manual Honorarium payment omits
// it) — RPR-6861/6862. `fee` is the remuneration rate as a string, matching the manual dialog's
// payload shape. Callers pass the *live* row/remuneration re-read at confirm time (the rate is the
// amount paid, and the row may have changed while the confirm dialog was open).
globalThis.buildIdiGeneratePayload = function (idiProjectId, stakeholder, remuneration) {
  return {
    idi_project_id: idiProjectId,
    fee: remuneration.rate.toString(),
    payer: stakeholder.stakeholder,
    reason: remuneration.reason || '',
    is_idi_generation: true
  };
};

// Payment Type choices for the selected survey / IDI project on the New Manual Payment dialog. An
// IDI project has no licence attached, so Client Payment is not offered — only RPR Payment.
// `constants` is the CONSTANTS service.
globalThis.availablePaymentTypeOptions = function (options, survey, constants) {
  if (!survey?.is_idi) {
    return options;
  }
  return options.filter((opt) => opt.value === constants.paymentType.RPR_PAYMENT);
};
